import React from 'react';

import ExternalLinkCard from 'src/common/components/external-link';
import { ViewMicrosoftFile } from 'src/common/ViewMicrosoftFile';
import { useStepEditorContext } from 'src/store/step-editor';
import { isHtmlArtifactType, isMicrosoftOfficeType } from 'src/utils/mime';
import { HtmlArtifactFrame } from 'src/common/HtmlArtifactFrame';

interface Props {
  onExternalLinkNavigate?: () => void;
  disabled?: boolean;
}

const StepEditorExternalFile = (props: Props) => {
  const linkProperties = useStepEditorContext((state) => state.link);
  const { externalFile } = useStepEditorContext((state) => state.previewObject);
  const link = {
    ...externalFile,
    title: linkProperties['title'] || externalFile['name'],
    description: linkProperties['description'] || externalFile['description'],
    hide_image: linkProperties['hide_image'] || externalFile['hide_image'],
  };

  const type = externalFile?.type;

  // The editor's preview of a step. An HTML artifact renders here the same way
  // it does for a recipient, so what the sender sees is what gets sent (JOU-40).
  if (type && isHtmlArtifactType(type)) {
    // fillParent: this preview sits in .journey-experience-node, a fixed
    // viewport-height container. See the prop's note in HtmlArtifactFrame.
    return <HtmlArtifactFrame url={externalFile.url} title={externalFile?.name} fillParent />;
  }

  if (type && isMicrosoftOfficeType(type)) {
    return <ViewMicrosoftFile url={externalFile.url} className="rounded-lg" />;
  }

  return <ExternalLinkCard isThumbnailHidden={link.hide_image} link={link} isURLHidden {...props} isAttachment fileAssetId={externalFile?.id} />;
};

export default StepEditorExternalFile;
